var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.81158 0 0 3.81158 0 8.5C0 13.1884 3.81158 17 8.5 17C13.1884 17 17 13.1884 17 8.5C17 3.81158 13.1884 0 8.5 0ZM8.5 15.7653C4.49158 15.7653 1.23474 12.5084 1.23474 8.5C1.23474 4.49158 4.49158 1.23474 8.5 1.23474C12.5084 1.23474 15.7653 4.49158 15.7653 8.5C15.7653 12.5084 12.5084 15.7653 8.5 15.7653Z",
    fill: "#2F2FA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74417 7.58721C6.34703 7.58721 6.83575 7.09849 6.83575 6.49563C6.83575 5.89277 6.34703 5.40405 5.74417 5.40405C5.1413 5.40405 4.65259 5.89277 4.65259 6.49563C4.65259 7.09849 5.1413 7.58721 5.74417 7.58721Z",
    fill: "#2F2FA2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4395 7.58721C12.0423 7.58721 12.5311 7.09849 12.5311 6.49563C12.5311 5.89277 12.0423 5.40405 11.4395 5.40405C10.8366 5.40405 10.3479 5.89277 10.3479 6.49563C10.3479 7.09849 10.8366 7.58721 11.4395 7.58721Z",
    fill: "#2F2FA2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5062 9.98511C11.202 9.84195 10.8262 9.96722 10.6831 10.2714C10.2715 11.1125 9.44833 11.6314 8.49991 11.6314C7.56938 11.6314 6.72833 11.1125 6.31675 10.2714C6.17359 9.96722 5.7978 9.84195 5.49359 9.98511C5.18938 10.1283 5.06412 10.5041 5.20728 10.8083C5.8157 12.0609 7.08622 12.8483 8.48201 12.8483C9.8778 12.8483 11.1662 12.0788 11.7746 10.8083C11.9357 10.5041 11.8104 10.1462 11.5062 9.98511Z",
    fill: "#2F2FA2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.7d98ec13.svg";
export { ForwardRef as ReactComponent };